module.exports = __webpack_public_path__ + "static/media/projects_2.218146be.svg";